import type { TerminalClassNames } from "./tokens";

/**
 * Default slot classes are stable, semantic `rt-*` names styled by the shipped
 * `styles.css` — so the control looks right with zero Tailwind. To restyle a
 * slot, pass `theme.classNames[slot]`; the value REPLACES the default, which is
 * where Tailwind users drop in utility strings (e.g. "fixed bottom-0 …").
 */
export const DEFAULT_CLASSNAMES: TerminalClassNames = {
  root: "rt-root",
  statusBar: "rt-statusbar",
  statusBarButton: "rt-statusbar-button",
  statusBarLabel: "rt-statusbar-label",
  panel: "rt-panel",
  panelHeader: "rt-panel-header",
  messageList: "rt-message-list",
  message: "rt-message",
  messageUser: "rt-message--user",
  messageAssistant: "rt-message--assistant",
  messageSystem: "rt-message--system",
  messageError: "rt-message--error",
  inputBar: "rt-input-bar",
  input: "rt-input",
  sendButton: "rt-send-button",
  resizeHandle: "rt-resize-handle",
  providerSwitch: "rt-provider-switch",
};
